import { onMounted, onUnmounted, ref } from "vue";

export function useOnlineStatus() {
  const isOnline = ref(typeof navigator === "undefined" || navigator.onLine !== false);

  const sync = () => {
    isOnline.value = navigator.onLine !== false;
  };

  onMounted(() => {
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
  });

  onUnmounted(() => {
    window.removeEventListener("online", sync);
    window.removeEventListener("offline", sync);
  });

  return { isOnline };
}
